import React from 'react';

import Button from 'react-bootstrap/lib/Button'
import Col from 'react-bootstrap/lib/Col'
import Modal from 'react-bootstrap/lib/Modal'
import Row from 'react-bootstrap/lib/Row'


import {TC_APPLY} from '../../constants/app/pdpConstants';
import apiManager from "../../utils/apiManager";
import {espotAPI} from "../../../public/constants/constants";
class TermsAndCondition extends React.Component {
  constructor() {
    super();
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false,
      promoEspotData:'',
    }
  }

  /* Handle Modal Close */
  handleClose() {
    this.setState({ show: false });
  }

  /* Handle Modal Show */
  handleShow() {
    this.setState({ show: true });
  }
  componentDidMount(){
    {this.props.offersEspot!=''?
    this.updatePromoEspot(this.props.offersEspot)
      :''}

  }

  updatePromoEspot(espotNAme){
    const espotPdpApi = espotAPI + espotNAme;
    apiManager
      .get(espotPdpApi)
      .then(response => {
        this.setState({
          promoEspotData: response.data,
        });    
      })
      .catch(error => {});
  }
  render () {
    return (
      <>
        <a className='emiDetails'  onClick={this.handleShow}>
          {this.props.displayText && this.props.displayText!=''?
            this.props.displayText
            :
            TC_APPLY
          }
        </a>
        <Modal className='modal_emiInstallment' show={this.state.show} onHide={this.handleClose}>
          <Modal.Body>
            <Button className="close" onClick={this.handleClose}></Button>
            <Row>
              <Col xs={12} md={12}>
                <div className='emi_modal'>
                  {/* <div dangerouslySetInnerHTML={{ __html:this.props.offersEspot!=''?this.state.promoEspotData.data.content: this.props.espotPromo.data.content }} /> */}
                  {
                  this.props.offersEspot!='' && this.state.promoEspotData!=''?
                    <div dangerouslySetInnerHTML={{ __html: this.state.promoEspotData.data.content }} />
                  :
                  <div dangerouslySetInnerHTML={{ __html:  this.props.espotPromo ? this.props.espotPromo.data.content : ''  }} />
                  }
                  {/* <div dangerouslySetInnerHTML={{ __html: this.props.espotPromo.data.content }} />                   */}
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default TermsAndCondition;
